import { FC } from 'react';
import { FavoriteToggle } from '#baseMenu/components/controls/favorite-toggle';
import { MiddleButton } from '#baseMenu/components/controls/middle-button/MiddleButton';

const Controls: FC = () => (
  <>
    <FavoriteToggle />
    <MiddleButton />
  </>
);

export { Controls };
